import { MixpanelEvents } from '~/core/service/mixpanel';
import type {
	ClearedFilters,
	EmptyStateFilter,
	CompleteFiltersAppliedClick,
	SuggestionFilterClicked,
	FiltersAppliedClick
} from '~/types/mixpanel';
import { safeTrack } from '~~/utils';

export const useTrackSearchPropertyEvents = () => {
	const trackFiltersCleared = (params: ClearedFilters) => {
		safeTrack(MixpanelEvents.FILTERS_CLEARED, params);
	};

	const trackEmptyStateFilter = (params: EmptyStateFilter) => {
		safeTrack(MixpanelEvents.EMPTY_STATE_FILTER, params);
	};

	const trackSuggestionFilter = (params: SuggestionFilterClicked) => {
		safeTrack(MixpanelEvents.FILTER_BY_SUGGEST, params);
	};

	const trackFilterApplied = (params: CompleteFiltersAppliedClick) => {
		safeTrack(MixpanelEvents.FILTER_APPLIED, params);
	};

	const trackFiltersAppliedResumed = (params: FiltersAppliedClick) => {
		safeTrack(MixpanelEvents.FILTER_APPLIED, params);
	};

	return {
		trackSuggestionFilter,
		trackEmptyStateFilter,
		trackFilterApplied,
		trackFiltersAppliedResumed,
		trackFiltersCleared
	};
};
